export default __webpack_public_path__ + "static/media/update_google_sheet_icon.f7818bd7.svg";